import styled, { css } from 'styled-components';

import { Spacer } from '@ontruck/orc';

const blockStyles = ({ cellWidth, fullHeight }) => css`
  ${cellWidth &&
  `
    width: ${cellWidth}px;
    min-width: ${cellWidth}px;
  `};
  ${fullHeight &&
  `
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    line-height: 1.3;
  `}
`;

const multilineStyles = ({ multiline }) =>
  multiline &&
  css`
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    line-height: 1.3;
  `;

const textStyles = ({ textAlign = 'left' }) => css`
  text-align: ${textAlign};
`;

const borderStyles = ({ borderLeft }) =>
  borderLeft &&
  css`
    border-left: 1px solid var(--greyMouse);
  `;

const StyledCell = styled(Spacer).attrs(() => ({
  mRight: 'S',
}))`
  ${blockStyles}
  ${multilineStyles}
  ${textStyles}
  ${borderStyles}
`;

export default StyledCell;
